import React from 'react';

import styles from './SuggestedDocument.module.scss';
import SuggestionCard from './SuggestionCard';

interface SuggestedDocumentProps {
    title: string;
    handleAdd: () => void;
    disabled?: boolean;
}

const SuggestedDocument: React.FC<SuggestedDocumentProps> = ({ title, handleAdd, disabled }) => {
    return (
        <SuggestionCard handleAdd={handleAdd} disabled={disabled}>
            <div className={styles.textContent}>
                <div className={styles.title}>{title}</div>
                <span className={styles.label}>Suggested Document</span>
            </div>
        </SuggestionCard>
    );
};

export default SuggestedDocument;
